module.exports = __webpack_public_path__ + "media/images/image_checkin_info2-a4035245093018e67f1d9973c5a8355d.jpg";